// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"cc678e4d","216":"7099bd73","297":"8176a0f6","418":"77d0528e","453":"bde05e91","470":"80ebfd49","491":"2a3ab9e2","501":"cce7c396","534":"c50509a7","663":"9fd5d7e3","768":"b7a97620","821":"dac52b75","925":"1b8ef9f3"}[chunkId] + ".chunk.js";
};